//@flow
import _ from 'lodash';
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from './../../components/inputs/FormInput';
import { objectsConstants } from '../../_constants/objects.constants';
import { formatterHelper } from '../../_helpers/formatter.helper';
import SelectInput from '../../components/inputs/SelectInput';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class EmpresaFinanceiroListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-4">
          <FormInput
            label="Nome da empresa"
            placeholder={'Nome'}
            id={'namefilter'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            value={entity.nome}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <SelectInput
            id={'origem'}
            options={[
              { label: 'SASC CM', value: 'SISTEMA' },
              { label: 'MetaDoctor', value: 'SSO_META' },
            ]}
            returnFullObject={false}
            label="Origem do cadastro"
            labelKey={'label'}
            valueKey={'value'}
            name={'origem'}
            value={entity.origem}
            onChange={(name, value) => {
              this.props.onChangeDate(name, value)
            }
            }
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <SelectInput
            id={'bloqueadoFencom'}
            options={[
              { label: 'Sim', value: true },
              { label: 'Não', value: false },
            ]}
            returnFullObject={true}
            label="Bloqueio Fencom?"
            labelKey={'label'}
            valueKey={'value'}
            name={'bloqueadoFencom'}
            value={
              _.isBoolean(entity.bloqueadoFencom)
                ? formatterHelper.getEnum(
                  entity.bloqueadoFencom,
                  objectsConstants.SIM_NAO
                )
                : entity.bloqueadoFencom
            }
            onChange={(name, value) => {
              this.props.onChangeDate(name, value.value)
            }
            }
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
